import { AlertVariant } from 'features/assessments/constants';
import React, { createContext, useContext, useState, PropsWithChildren } from 'react';

interface OfflineContextType {
  varient: AlertVariant;
  setVarient: (varient: AlertVariant) => void;
  isOnline: boolean;
  setIsOnline: (isOnline: boolean) => void;
  showOfflineAlert: boolean;
  setShowOfflineAlert: (show: boolean) => void;
}

const OfflineContext = createContext<OfflineContextType>({
  varient: 'offline-alert',
  setVarient: () => {},
  isOnline: true,
  setIsOnline: () => {},
  showOfflineAlert: false,
  setShowOfflineAlert: () => {},
});

export const OfflineContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [varient, setVarient] = useState<AlertVariant>('offline-alert');
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [showOfflineAlert, setShowOfflineAlert] = useState<boolean>(false);

  return (
    <OfflineContext.Provider
      value={{
        varient,
        setVarient,
        isOnline,
        setIsOnline,
        showOfflineAlert,
        setShowOfflineAlert,
      }}
    >
      {children}
    </OfflineContext.Provider>
  );
};

export const useOfflineContext = () => useContext(OfflineContext);
